<template>
  <section>
    <b-overlay
      id="overlay-background"
      :show="overlay"
      :opacity="0.5"
      rounded="sm"
      :spinner-type="overlay_type"
    >
      <b-container id="signup">
        <h2 class="text-center mb-3">報名發表會</h2>
        <b-form class="signup">
          <b-row class="mb-3">
            <b-col sm="2">
              <label>姓名</label>
            </b-col>
            <b-col sm="10" md="auto">
              <b-form-input
                placeholder="請輸入姓名"
                v-model="SignData.name"
                :state="CheckState(SignData.name, true)"
              ></b-form-input>
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col sm="2">
              <label>單位</label>
            </b-col>
            <b-col sm="10" md="auto">
              <b-form-radio name="govORsch" v-model="govORsch" value="0"
                >政府部門</b-form-radio
              >
              <b-form-radio name="govORsch" v-model="govORsch" value="1"
                >學術單位</b-form-radio
              >
              <b-form-radio name="govORsch" v-model="govORsch" value="2"
                >公司行號</b-form-radio
              >
            </b-col>
            <b-col sm="10" md="auto">
              <b-row class="mb-1">
                <b-form-input
                  v-model="SignData.position"
                  placeholder="請輸入單位名稱"
                  :state="CheckState(SignData.position, true)"
                ></b-form-input>
              </b-row>
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col sm="2">
              <label>性別</label>
            </b-col>
            <b-col sm="10" md="auto">
              <b-form-radio name="gender" v-model="SignData.sex" value="0"
                >男</b-form-radio
              >
              <b-form-radio name="gender" v-model="SignData.sex" value="1"
                >女</b-form-radio
              >
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col sm="2">
              <label>手機號碼</label>
            </b-col>
            <b-col sm="10" md="auto">
              <b-form-input
                placeholder="請輸入手機號碼"
                v-model="SignData.phone"
                :state="CheckState(SignData.phone, CheckPhone)"
              ></b-form-input>
              <b-form-invalid-feedback :state="CheckPhone"
                >請填寫正確的手機號碼格式 Ex:0912345678</b-form-invalid-feedback
              >
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col sm="2">
              <label>身分證號碼 (非必填)</label>
            </b-col>
            <b-col sm="10" md="auto">
              <b-form-input
                placeholder="請輸入身分證號碼"
                v-model="SignData.idNum"
                :state="CheckState(SignData.idNum, CheckidNum)"
              ></b-form-input>
              <b-form-invalid-feedback :state="CheckidNum"
                >請填寫正確的身分證格式</b-form-invalid-feedback
              >
              <a>如要申請公務人員終身學習時數，身分證請務必填寫。</a>
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col sm="2">
              <label>電子信箱</label>
            </b-col>
            <b-col sm="10" md="auto" id="cmail">
              <b-form-input
                type="email"
                placeholder="請輸入電子信箱"
                v-model="SignData.email"
                :state="CheckState(SignData.email, CheckMail)"
              ></b-form-input>
              <b-form-invalid-feedback :state="CheckMail"
                >請填寫正確的Email格式</b-form-invalid-feedback
              >
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col sm="2">
              <label>飲食需求</label>
            </b-col>
            <b-col sm="10" md="auto">
              <b-form-radio name="Lunch" v-model="SignData.Lunch" value="0"
                >葷食</b-form-radio
              >
              <b-form-radio name="Lunch" v-model="SignData.Lunch" value="1"
                >素食</b-form-radio
              >
              <b-form-radio name="Lunch" v-model="SignData.Lunch" value="2"
                >不用餐</b-form-radio
              >
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col sm="2">
              <label>參加方式</label>
            </b-col>
            <b-col sm="10" md="auto">
              <b-form-radio name="Join" v-model="SignData.Join" value="0"
                >實體發表</b-form-radio
              >
              <b-form-radio name="Join" v-model="SignData.Join" value="1"
                >線上直播</b-form-radio
              >
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col sm="2">
              <label>參加的場次</label>
            </b-col>
            <b-col sm="10" md="auto">
              <b-form-checkbox v-model="session1"
                >10/4(一) NGIS整合建置應用成果/柏拉圖廳</b-form-checkbox
              >
              <b-form-checkbox v-model="session2"
                >10/5(二) 3D國家底圖建置現況及應用/柏拉圖廳</b-form-checkbox
              >
              <b-form-checkbox v-model="session3"
                >10/6(三) DTM加值應用成果/GIS競賽頒獎/拉斐爾廳</b-form-checkbox
              >
              <b-form-checkbox v-model="session4"
                >10/6(三)
                三維空間資訊基礎環境共構及資料聯盟系統技術應用成果/米開朗基羅廳</b-form-checkbox
              >
              <b-form-checkbox v-model="session5"
                >10/7(四) 高精地圖標準及智能移動測繪技術/洛克廳</b-form-checkbox
              >
              <b-form-checkbox v-model="session6"
                >10/8(五) Space-borne Earth observation & GIS - International partnership</b-form-checkbox
              >
            </b-col>
          </b-row>
          <hr />
          <h5>COVID-19防疫調查表</h5>
          <p>
            為防範COVID-19疫情，主辦方為維護整場活動之健康與安全，我們需嚴格審視活動進行及評估所有風險。請
            與會貴賓配合下列問卷之調查，詳如以下說明：
          </p>

          <hr />
          <b-row class="mb-3">
            <b-col sm="2">
              <label>最近一個月是否出現以下症狀?</label>
            </b-col>
            <b-col sm="10" md="auto">
              <b-form-radio name="COVID1" v-model="SignData.Covid1" value="0"
                >否</b-form-radio
              >
              <b-form-radio name="COVID1" v-model="SignData.Covid1" value="1"
                >發燒(≧38℃)</b-form-radio
              >
              <b-form-radio name="COVID1" v-model="SignData.Covid1" value="2"
                >咳嗽/喉嚨痛/流鼻水</b-form-radio
              >
              <b-form-radio name="COVID1" v-model="SignData.Covid1" value="3"
                >呼吸道窘迫症狀(呼吸急促、呼吸困難)</b-form-radio
              >
              <b-form-radio name="COVID1" v-model="SignData.Covid1" value="4"
                >肌肉酸痛/關節酸痛</b-form-radio
              >
              <b-form-radio name="COVID1" v-model="SignData.Covid1" value="5"
                >其他</b-form-radio
              >
              <b-form-input
                v-if="SignData.Covid1 == 5"
                v-model="SignData.Covid1_Another"
                placeholder="請輸入詳細說明"
                :state="CheckState(SignData.Covid1_Another, true)"
              ></b-form-input>
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col sm="2">
              <label
                >最近一個月是否有出國旅遊/接觸史(含轉機)?<br/>
                * 若回答 「是」, 請填寫旅遊/接觸史(含轉機)地點
              </label>
            </b-col>
            <b-col sm="10" md="auto">
              <b-form-radio name="COVID2" v-model="SignData.Covid2" value="0"
                >否</b-form-radio
              >
              <b-form-radio name="COVID2" v-model="SignData.Covid2" value="1"
                >是</b-form-radio
              >
              <b-form-input
                v-if="SignData.Covid2 == 1"
                v-model="SignData.Covid2_Another"
                placeholder="請輸入詳細說明"
                :state="CheckState(SignData.Covid2_Another, true)"
              ></b-form-input>
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col sm="2">
              <label
                >您或您同住家屬、親友是否曾與感染嚴重特殊傳染性肺炎COVID-19
                病患曾有接觸？<br />
                * 若回答 「是」, 請填寫您與病患接觸日期
              </label>
            </b-col>
            <b-col sm="10" md="auto">
              <b-form-radio name="COVID3" v-model="SignData.Covid3" value="0"
                >否</b-form-radio
              >
              <b-form-radio name="COVID3" v-model="SignData.Covid3" value="1"
                >是</b-form-radio
              >
              <b-form-input
                v-if="SignData.Covid3 == 1"
                v-model="SignData.Covid3_Another"
                placeholder="請輸入詳細說明"
                :state="CheckState(SignData.Covid3_Another, true)"
              ></b-form-input>
            </b-col>
          </b-row>

          <hr />

          <b-row class="mb-3">
            <b-col sm="10" offset-md="2" md="auto">
              <b-form-checkbox v-model="terms1"
                >我已經確認上述資料皆與證件相符</b-form-checkbox
              >
              <b-form-checkbox v-model="terms2"
                >我已同意<b-link href="#" v-b-modal.modal-1
                  >『個資同意聲明』</b-link
                ></b-form-checkbox
              >
              <b-form-checkbox v-model="terms3"
                >我已詳閱並如實填寫上述「COVID-19 防疫調查表」</b-form-checkbox
              >
              <b-modal
                id="modal-1"
                title="個資同意聲明"
                size="lg"
                ok-only
                ok-title="關閉"
              >
                <dl>
                  <dt>蒐集機關</dt>
                  <dd>逢甲大學地理資訊系統研究中心、易圖科技。</dd>
                  <dt>蒐集目的</dt>
                  <dd>
                    「內政部落實智慧國土計畫暨空間測繪技術發表週」報名之用
                  </dd>
                  <dt>資料類別</dt>
                  <dd>
                    個人身分證字號、姓名、生日、性別、服務單位、職稱、電子郵件、電話、手機、地址。
                  </dd>
                  <dt>使用方式</dt>
                  <dd>
                    由系統登錄後，於資料庫存放，由專案活動負責人員進行報名確認事宜。
                  </dd>
                  <dt>使用期限</dt>
                  <dd>
                    專案活動結束後或登錄公務人員學習時數後屆滿報名完成後，您得以下列聯絡方式行使查閱、更正等個人資料保護法第3條的當事人權利。
                  </dd>
                </dl>
                <p>如您提供的資料不完整或不確實，將無法完成本次報名作業。</p>
              </b-modal>
              <b-modal
                id="modal-terms"
                v-model="modal_terms_show"
                title="報名失敗"
                size="lg"
                ok-only
                ok-title="關閉"
              >
                <p>
                  請勾選個資同意聲明、確認證件、COVID-19
                  防疫調查表，否則將無法完成本次報名作業。
                </p>
              </b-modal>
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col sm="10" offset-md="2" md="auto">
              <b-button
                type="button"
                variant="primary"
                size="lg"
                @click="CheckTerms"
                >送出</b-button
              >
            </b-col>
          </b-row>
        </b-form>
        <b-modal
          id="modal-2"
          v-model="modal_2_show"
          title="報名完成"
          size="lg"
          ok-only
          ok-title="關閉"
          @ok="GoToPathHome"
        >
          <p>感謝您報名國家底圖空間資訊應用成果發表週。</p>
          <p>確認信函以寄至：{{ SignData.email }}</p>
          <p>如未收到【確認信】，請至【垃圾郵件匣】查看。</p>
        </b-modal>
        <b-modal
          id="modal-timeOut"
          v-model="modal_timeOut_show"
          title="報名日期已截止"
          size="lg"
          ok-only
          ok-title="關閉"
        >
          <p>報名日期:</p>
          <p>2021/9/11 上午 11:00 ~ 2021/9/26 下午 11:59</p>
        </b-modal>
      </b-container>
    </b-overlay>
  </section>
</template>
<script>
import {
  apiGetOpen2,
  apiCheckRegister,
  apiGetAT_ID,
  apiNewRegister,
  apiGetKey,
  apiGetToken,
  apiGetMailToken,
  apiSendMail,
  apiSetLogRequest,
} from "../api/API";
export default {
  data() {
    return {
      State: true,
      session1: true,
      session2: true,
      session3: true,
      session4: true,
      session5: true,
      session6: true,
      terms1: false,
      terms2: false,
      terms3: false,
      govORsch: "0",
      SignData: {
        name: "",
        position: "",
        phone: "",
        idNum: "",
        sex: "0",
        email: "",
        Lunch: "0",
        Join: "0",
        Covid1: "0",
        Covid1_Another: "",
        Covid2: "0",
        Covid2_Another: "",
        Covid3: "0",
        Covid3_Another: "",
      },
      modal_terms_show: false,
      modal_2_show: false,
      modal_timeOut_show: false,
      overlay: false,
      overlay_type: "border",
    };
  },
  mounted() {
    this.CheckIsOpen();
    this.getSessionCount();
  },
  methods: {
    
    async SendMail(id, count) {
      try {
        const token = (await apiGetMailToken()).data;
        //console.log(token);
        var sessionvalue1 = "";
        if (this.session1) sessionvalue1 = "1";
        var sessionvalue2 = "";
        if (this.session2) sessionvalue2 = "1";
        var sessionvalue3 = "";
        if (this.session3) sessionvalue3 = "1";
        var sessionvalue4 = "";
        if (this.session4) sessionvalue4 = "1";
        var sessionvalue5 = "";
        if (this.session5) sessionvalue5 = "1";
        var sessionvalue6 = "";
        if (this.session6) sessionvalue6 = "1";
        var info = {
          id: id,
          mail: this.SignData.email,
          name: this.SignData.name,
          join: this.SignData.Join,
          session1: sessionvalue1,
          session2: sessionvalue2,
          session3: sessionvalue3,
          session4: sessionvalue4,
          session5: sessionvalue5,
          session6: sessionvalue6,
          TokenID: "",
          Token: token,
          Page: "",
        };
        const sendMail = JSON.parse((await apiSendMail(info)).data);
        //console.log(sendMail);
        if (sendMail.Status) {
          this.overlay = false;
          this.modal_2_show = true;
        } else {
          if (count <= 5) {
            count++;
            this.SendMail(id, count);
          } else {
            const token = (await apiGetMailToken()).data;
            var lo = {
              Id: this.SignData.email,
              Message: "寄件失敗",
              TokenID: "",
              Token: token,
              Page: "",
            };
            const SetLog = JSON.parse((await apiSetLogRequest(lo)).data);
            console.error(SetLog);
            this.overlay = false;
            alert("寄件失敗，請聯絡相關人員 ");
          }
        }
      } catch (err) {
        if (count <= 5) {
          count++;
          this.SendMail(id, count);
        } else {
          const token = (await apiGetMailToken()).data;
          var logs = {
            Id: this.SignData.email,
            Message: err,
            TokenID: "",
            Token: token,
            Page: "",
          };
          const SetLog = JSON.parse((await apiSetLogRequest(logs)).data);
          console.error(SetLog);
          this.overlay = false;
          alert("寄件出現錯誤，請聯絡相關人員 ");
        }
      }
    },
    async Register() {
      try {
        this.overlay = true;
        const key = (await apiGetKey()).data[0]["Key"];
        //console.log(key);
        const token = (await apiGetToken(key)).data[0]["Token"];
        //console.log(token);
        const AT_ID = (await apiGetAT_ID(token)).data[0]["AT_ID"];
        //console.log(AT_ID);
        var lunch = "";
        if (this.SignData.Lunch == "0") {
          lunch = "CV20210826174544217";
        } else if (this.SignData.Lunch == "1") {
          lunch = "CV20210826174548873";
        } else {
          lunch = "CV20210826174552616";
        }

        //CL20180307140909094
        var RegisterData = [
          //姓名
          { RD_CLID: "CL20190311182727127", RD_Value: this.SignData.name },
          //稱謂
          { RD_CLID: "CL20180307140916893", RD_Value: this.SignData.position },
          //性別
          {
            RD_CLID: "CL20190311193313384",
            RD_Value:
              this.SignData.sex == "0"
                ? "CV20190311193344352"
                : "CV20190311193335665",
          },
          //手機號碼
          {
            RD_CLID: "CL20180314141037348",
            RD_Value: this.SignData.phone,
          },
          //身分證號
          { RD_CLID: "CL20180307140846991", RD_Value: this.SignData.idNum },
          //飲食需求(單選)
          {
            RD_CLID: "CL20210826174533475",
            RD_Value: lunch,
          },
          //參加方式
          {
            RD_CLID: "CL20210826174412786",
            RD_Value:
              this.SignData.Join == "0"
                ? "CV20210826174443609"
                : "CV20210826174447609",
          },
          //COVID-19是否出現症狀-其他
          {
            RD_CLID: "CL20210826173914468",
            RD_Value: this.SignData.Covid1_Another,
          },
          //COVID-19出國史-其他
          {
            RD_CLID: "CL20210826173929698",
            RD_Value: this.SignData.Covid2_Another,
          },
          //COVID-19病患接觸史-其他
          {
            RD_CLID: "CL20210826173944377",
            RD_Value: this.SignData.Covid3_Another,
          },
        ];
        //單位
        var gscVal = "";
        if (this.govORsch == "0") {
          gscVal = "CV20201022102804909";
        }
        if (this.govORsch == "1") {
          gscVal = "CV20201022102816730";
        }
        if (this.govORsch == "2") {
          gscVal = "CV20201016141128829";
        }
        RegisterData.push({ RD_CLID: "CL20201006102625094", RD_Value: gscVal });

        //COVID-19是否出現症狀
        var covid1_item = "";
        if (this.SignData.Covid1 == "0") {
          covid1_item = "CV20210826215421777";
        }
        if (this.SignData.Covid1 == "1") {
          covid1_item = "CV20210826215426463";
        }
        if (this.SignData.Covid1 == "2") {
          covid1_item = "CV20210826215430838";
        }
        if (this.SignData.Covid1 == "3") {
          covid1_item = "CV20210826215437511";
        }
        if (this.SignData.Covid1 == "4") {
          covid1_item = "CV20210826215443042";
        }
        if (this.SignData.Covid1 == "5") {
          covid1_item = "CV20210826215447980";
        }
        RegisterData.push({
          RD_CLID: "CL20210826215321959",
          RD_Value: covid1_item,
        });
        //COVID-19出國史
        var covid2_item = "";
        if (this.SignData.Covid2 == "0") {
          covid2_item = "CV20210826215540889";
        }
        if (this.SignData.Covid2 == "1") {
          covid2_item = "CV20210826215545500";
        }
        RegisterData.push({
          RD_CLID: "CL20210826215520054",
          RD_Value: covid2_item,
        });
        //COVID-19病患接觸史
        var covid3_item = "";
        if (this.SignData.Covid3 == "0") {
          covid3_item = "CV20210826215559261";
        }
        if (this.SignData.Covid3 == "1") {
          covid3_item = "CV20210826215554968";
        }
        RegisterData.push({
          RD_CLID: "CL20210826215530907",
          RD_Value: covid3_item,
        });

        var value = "";
        if (this.session1) value += "CV20210826174247418,"; //NGIS整合建置應用成果/柏拉圖廳
        if (this.session2) value += "CV20210826174253406,"; //3D國家底圖建置現況及應用/柏拉圖廳
        if (this.session3) value += "CV20210826174258303,"; //DTM加值應用成果/GIS競賽頒獎/拉斐爾廳
        if (this.session4) value += "CV20210826174303826,"; //三維空間資訊基礎環境共構及資料聯盟系統技術應用成果/米開朗基羅廳
        if (this.session5) value += "CV20210826174311146,"; //高精地圖標準及智能移動測繪技術/洛克聽
        if (this.session6) value += "CV20210826174317005,"; //地球觀測應用成果/廳別不確定
        RegisterData.push({ RD_CLID: "CL20210826174229969", RD_Value: value });

        var Register = {
          RG_ATID: AT_ID,
          RG_Email: this.SignData.email,
          RG_CName: this.SignData.name,
          RG_LName: "",
          RG_FName: "",
          VolumnData: RegisterData,
        };
        //console.log(Register);

        const NewRegister = await apiNewRegister(token, Register);
        //console.log(NewRegister.data["Result"]);

        if (
          NewRegister.data["Result"] ==
          "該活動尚未開啟報名(This activity is not open yet.)"
        ) {
          this.modal_timeOut_show = true;
        } else {
          const isRegister = (await apiCheckRegister(this.SignData.email))
            .data[0]["IsRegister"];
          if (isRegister == "true") {
            this.SendMail(NewRegister.data["Result"], 1);
          } else {
            this.overlay = false;
            alert("報名失敗");
          }
        }
      } catch (err) {
        console.error(err);
        alert("註冊出現錯誤，請聯絡相關人員");
      }
    },
    async CheckRegister() {
      try {
        const isRegister = (await apiCheckRegister(this.SignData.email))
          .data[0]["IsRegister"];
        if (isRegister == "false") {
          this.Register();
        } else {
          alert("此Emial已有報名過");
        }
      } catch (err) {
        console.error(err);
        alert("檢查出現錯誤，請聯絡相關人員");
      }
    },
    CheckState(val, CMail) {
      if ((val == "" || !CMail) && !this.State) return false;
      else return null;
    },
    CheckData() {
      if (
        this.SignData.name == "" ||
        this.SignData.email == "" ||
        this.SignData.position == ""
      ) {
        this.State = false;
        window.location.hash = "#sign";
      } else if (
        this.session1 == false &&
        this.session2 == false &&
        this.session3 == false &&
        this.session4 == false &&
        this.session5 == false &&
        this.session6 == false
      ) {
        alert("請至少參加一場次");
      } else if (
        this.SignData.Covid1 == 5 ||
        this.SignData.Covid2 == 1 ||
        this.SignData.Covid3 == 1
      ) {
        var err = 1;
        if (this.SignData.Covid1 == 5) {
          if (this.SignData.Covid1_Another == "") {
            alert("請輸入原因");
          } else {
            err = null;
          }
        }
        if (this.SignData.Covid2 == 1) {
          if (this.SignData.Covid2_Another == "") {
            alert("請輸入原因");
          } else {
            err = null;
          }
        }
        if (this.SignData.Covid3 == 1) {
          if (this.SignData.Covid3_Another == "") {
            alert("請輸入原因");
          } else {
            err = null;
          }
        }
        if (err == null) {
          this.CheckRegister();
        }
      } else {
        // if (!this.CheckMail) {
        //   this.State = false;
        //   window.location.hash = "#sign";
        // } else {
        this.CheckRegister();
        //}
      }
    },
    CheckTerms() {
      if (
        this.terms1 == false ||
        this.terms2 == false ||
        this.terms3 == false
      ) {
        this.modal_terms_show = true;
      } else {
        this.CheckData();
      }
    },
    async CheckIsOpen() {
      const key = (await apiGetKey()).data[0]["Key"];
      const token = (await apiGetToken(key)).data[0]["Token"];
      const AT_ID = (await apiGetAT_ID(token)).data[0]["AT_ID"];
      const isOpen = (await apiGetOpen2(token, AT_ID)).data[0]["IsOpen"];
      if (isOpen != "true") {
        this.modal_timeOut_show = true;
        this.overlay_type = "";
        this.overlay = true;
      }
    },
  },
  computed: {
    CheckMail() {
      const mailRegExp = new RegExp(
        "^\\w+((-\\w+)|(\\.\\w+))*\\@[A-Za-z0-9]+((\\.|-)[A-Za-z0-9]+)*\\.[A-Za-z0-9]+$"
      );
      return mailRegExp.test(this.SignData.email);
    },
    CheckidNum() {
      const idRegExp = new RegExp(
        "^[A-Za-z]+[0-9]+[0-9]+[0-9]+[0-9]+[0-9]+[0-9]+[0-9]+[0-9]+[0-9]+$"
      );
      return idRegExp.test(this.SignData.idNum);
    },
    CheckPhone() {
      var MobileReg = /^(09)[0-9]{8}$/;
      return this.SignData.phone.match(MobileReg) ? true : false;
    },
  },
};
</script>